export default __webpack_public_path__ + "static/media/facebookPixel.b7a2878b.svg";